import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { AuthenticationService } from './authentication.service'
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { CartItem } from '../models/cart.model'
import { IProductListing } from './market.service'
import { Md5 } from 'ts-md5'

export interface Product {
  id: number
  name: string
  vendor: string
}
export interface IPriceTexts {
  priceText: string
  discountedPriceText: string
}
export interface IPrices {
  discount: number
  discountedPrice: number
  discountedPriceText: string
  price: number
  priceText: string
  customPrice?: number
}

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  constructor(
    private router: Router,
    private translate: TranslateService,
    private authService: AuthenticationService
  ) {}

  urlProductRoute(product) {
    return [product.id, this.productUrl(product.name, product.vendor)]
  }

  urlAbsoluteRoute(product) {
    return [this.translate.currentLang, 'buy'].concat(
      this.urlProductRoute(product)
    )
  }

  gotoProduct(product: Product) {
    this.router.navigate(this.urlAbsoluteRoute(product))
  }

  public productUrl(name: string, vendor?: string) {
    return (vendor ? vendor + '-' + name : name)
      .toLowerCase()
      .replace(new RegExp('[^a-z0-9]+', 'g'), '-')
      .replace(new RegExp('^-|-$', 'g'), '')
  }

  public createProductIdByName(productName: string): string {
    const formatedItemName = this.productUrl(productName)

    return Md5.hashStr(formatedItemName).toString()
  }

  translatePriceText(
    isReseller: boolean,
    discount: number,
    customPrice?: number
  ): IPriceTexts {
    let priceText, discountedPriceText: string
    if ((isReseller && discount > 0) || customPrice) {
      priceText = this.translate.instant('marketplace.lix_label_reseller')
      discountedPriceText = this.translate.instant('marketplace.reseller_label')
    } else {
      priceText = this.translate.instant('marketplace.vendor_label')
      discountedPriceText = this.translate.instant('marketplace.lix_label')
    }
    return { priceText, discountedPriceText }
  }

  calcPriceInformation(product: any, user: any) {
    let price, discount, discountedPrice
    const customPrice = 0
    const quantity = product.quantity || 1
    if (
      user &&
      user.isReseller &&
      product.discount > 0 &&
      !product.customPrice
    ) {
      price = product.price * quantity
      discount = (product.discount / 100) * price
      discountedPrice = price - discount
    } else if (user && product.customPrice > 0) {
      price = product.price * quantity
      discountedPrice = product.customPrice * quantity
      discount = price - discountedPrice
    } else {
      price = product.vendor_price * quantity
      discountedPrice = product.price * quantity
      discount = price - discountedPrice
    }
    return { price, discount, discountedPrice, customPrice }
  }
  getPriceInformation(product: IProductListing): Observable<IPrices> {
    return this.authService.userData.pipe(
      map((user) => {
        const { priceText, discountedPriceText } = this.translatePriceText(
          user && user.isReseller,
          product.discount,
          product.customPrice
        )
        const { price, discount, discountedPrice } = this.calcPriceInformation(
          product,
          user
        )
        return {
          price,
          discount,
          discountedPrice,
          priceText,
          discountedPriceText,
        }
      })
    )
  }

  getCartPriceInformation(cart: CartItem[]): Observable<IPrices> {
    // TODO: Try - Catch
    return this.authService.userData.pipe(
      map((user) => {
        let price = 0
        let discount = 0
        let discountedPrice = 0

        cart.forEach((item) => {
          const temp = this.calcPriceInformation(item, user)
          price += temp.price
          discount += temp.discount
          discountedPrice += temp.discountedPrice
        })
        const { priceText, discountedPriceText } = this.translatePriceText(
          user && user.isReseller,
          cart[0].discount,
          cart[0].customPrice
        )
        return {
          price,
          discount,
          discountedPrice,
          priceText,
          discountedPriceText,
        }
      })
    )
  }
}
